import { cn } from "@/utils/utils";
import { FC } from "react";

interface Props {
  label: string;
  onClick: () => void;
  isSelected: boolean;
}

const InterviewButton: FC<Props> = ({ label, onClick, isSelected }) => {
  return (
    <div
      className={cn(
        "flex text-[#A3A7AF] justify-center items-center cursor-pointer p-2 rounded-xl font-[500px]",
        isSelected ? "bg-[#F8F9FC] text-black" : ""
      )}
      onClick={onClick}
    >
      <p className="p-0 m-0">{label}</p>
    </div>
  );
};

export default InterviewButton;
